import React from "react";
import {Link} from "gatsby";
import {ChevronRightIcon} from '@heroicons/react/24/solid'
import {getSubPageTitle} from "../../utils/slug";

type Props = {
    directory? :string
}

export const BreadCrumbList:React.FunctionComponent<Props> = ({directory}) => {

    return (
        <div className="mb-4 text-gray-500">
            <Link to="/" >トップ</Link>&nbsp;<ChevronRightIcon width="1.25em" className="inline" />&nbsp;
            {directory? <Link to={"/" + directory + '/'}>{getSubPageTitle(directory)}</Link> : ''}
        </div>
    )

}
